<template>
  <div class="view-seller-offers-edit__documents">
    <div class="row">
      <input type="file" hidden ref="file" @change="upload" />

      <div class="col-6 col-xxs-12" v-if="innerFileData">
        <app-doc-item
          class="view-seller-offers-edit__documents-item"
          title="Паспорт качества"
          :size="innerFileData.size | fileSize()"
          :date="innerFileData.createdAt | dateFormat('dd.MM.yyyy HH:mm')"
          :url="innerFileData.url"
          @remove="removeSingle"
        />
      </div>

      <div class="col-12" v-if="isSingle && !innerFileData">
        <app-circle-btn
          isText
          color="green"
          type="add"
          size="small"
          class="view-seller-offers-edit__wrapper-link"
          @click="addSingle"
        >
          Загрузить документ
        </app-circle-btn>
        <small v-if="isErrorType" class="app-input-group__invalid">
          Недопустимый тип файла
        </small>
        <small v-if="isErrorSize" class="app-input-group__invalid">
          Загрузите файл меньше 20МБ
        </small>
      </div>
      <div class="col-12" v-if="!isSingle">
        <app-circle-btn
          isText
          color="green"
          type="add"
          size="small"
          class="view-seller-offers-edit__wrapper-link"
        >
          Загрузить ещё документ
        </app-circle-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerOffersFormDocuments',
  components: {
    AppCircleBtn: () => import('@/components/ui/AppCircleBtn'),
    AppDocItem: () => import('@/components/ui/AppDocItem'),
  },
  props: {
    isSingle: {
      type: Boolean,
    },
    passport: {
      default() {
        return {
          size: 0,
          date: '',
          url: '',
        };
      },
    },
    reset: {
      type: Boolean,
    },
    formData: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  data: () => ({
    objectFile: null,
    innerFileData: null,
    isErrorType: false,
    isErrorSize: false,
  }),
  watch: {
    reset(value) {
      if (value) {
        this.objectFile = null;
        this.innerFileData = null;
        this.isErrorType = false;
        this.isErrorSize = false;
      }
    },
  },
  mounted() {
    if (this.formData && !this.formData.uuid) {
      this.innerFileData = {
        createdAt: this.$options.filters.dateFormat(
          new Date(),
          'yyyy-MM-dd HH:mm:ss'
        ),
        size: this.formData.get('file').size,
        url: '',
      };
    } else {
      this.innerFileData = this.passport;
    }
  },
  methods: {
    /**
     * Загрузка файла
     */
    upload() {
      this.isErrorType = false;
      this.isErrorSize = false;
      if (!this.$refs.file.files) {
        this.$emit('upload', null);
        return false;
      }
      if (
        this.$refs.file.files[0].type !== 'application/pdf' &&
        this.$refs.file.files[0].type !== 'image/png' &&
        this.$refs.file.files[0].type !== 'image/jpeg' &&
        this.$refs.file.files[0].type !== 'image/jpg'
      ) {
        this.isErrorType = true;
        this.$emit('upload', null);
        return false;
      }

      if (this.$refs.file.files[0].size > 20971520) {
        this.isErrorSize = true;
        this.$emit('upload', null);
        return false;
      }

      // eslint-disable-next-line prefer-destructuring
      this.objectFile = this.$refs.file.files[0];
      const formData = new FormData();
      formData.append('file', this.objectFile);
      this.$emit('upload', formData);
      this.innerFileData = {
        createdAt: this.$options.filters.dateFormat(
          new Date(),
          'yyyy-MM-dd HH:mm:ss'
        ),
        size: this.objectFile.size,
        url: '',
      };
      return this.objectFile;
    },
    /**
     * Добавление одного файла
     */
    addSingle() {
      this.$refs.file.click();
    },
    /**
     * Удаление одного файла
     */
    removeSingle() {
      this.$refs.file.value = '';

      if (!/safari/i.test(navigator.userAgent)) {
        this.$refs.file.type = '';
        this.$refs.file.type = 'file';
      }
      this.innerFileData = null;
      this.$emit('upload', null);
    },
  },
};
</script>

<style lang="scss">
// -
</style>
